var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ico",
    d: "M19.7449 9.6875C19.7449 10.3247 19.2396 10.8203 18.6669 10.8203H17.589L17.6226 16.4844C17.6226 16.5906 17.6226 16.6968 17.6226 16.7676V17.334C17.6226 18.1482 17.0163 18.75 16.2752 18.75H15.7362C15.6688 18.75 15.6351 18.75 15.6014 18.75C15.5677 18.75 15.5004 18.75 15.4667 18.75H14.3887H13.5802C12.8054 18.75 12.2328 18.1482 12.2328 17.334V16.4844V14.2187C12.2328 13.6169 11.7275 13.0859 11.1548 13.0859H8.99882C8.39246 13.0859 7.92084 13.6169 7.92084 14.2187V16.4844V17.334C7.92084 18.1482 7.31448 18.75 6.57337 18.75H5.76489H4.68691C4.61954 18.75 4.58585 18.75 4.51848 18.75C4.48479 18.75 4.4511 18.75 4.41742 18.75H3.87843C3.10363 18.75 2.53096 18.1482 2.53096 17.334V13.3691C2.53096 13.3691 2.53096 13.3337 2.53096 13.2983V10.8203H1.45298C0.846615 10.8203 0.375 10.3247 0.375 9.6875C0.375 9.3689 0.47606 9.08569 0.711868 8.83789L9.33569 0.908203C9.5715 0.6604 9.84099 0.625 10.0768 0.625C10.3126 0.625 10.5821 0.695801 10.7842 0.872803L19.3744 8.83789C19.6439 9.08569 19.7786 9.3689 19.7449 9.6875Z",
    fill: "#E6E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1055 1.01933C9.6724 0.505463 10.5151 0.492409 11.0966 0.988485L19.8145 8.42595C20.4704 8.9855 20.5642 9.98991 20.0241 10.6694C19.4839 11.3488 18.5144 11.446 17.8585 10.8865L10.1488 4.30911L2.92656 10.8556C2.28712 11.4352 1.31518 11.3681 0.755671 10.7057C0.196162 10.0433 0.260958 9.03641 0.900397 8.4568L9.1055 1.01933Z",
    fill: "url(#paint0_linear_3390_281)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3390_281",
    x1: 0.375,
    y1: 1.6875,
    x2: 7.98577,
    y2: 15.5923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3677D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.ddb9429b48dd7301ff8a1b09de9e0690.svg";
export { ForwardRef as ReactComponent };